import React, {Component} from 'react'
import {Footer} from './Footer'
import { Container, Form, Row, Col, Button, Modal } from 'react-bootstrap'
import emailjs from 'emailjs-com'
import Recaptcha from 'react-recaptcha'
import {Navigation} from './Navigation'

export class Contacto extends Component{
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            recaptchaLoad: false,
            isVerified: false
        };
        this.ocultar = this.ocultar.bind(this)
        this.mostrar = this.mostrar.bind(this)
        this.sendEmail = this.sendEmail.bind(this)
        this.recaptchaLoaded = this.recaptchaLoaded.bind(this);
        this.verifiedRecaptcha = this.verifiedRecaptcha.bind(this);
    }
    ocultar(){
        this.setState({show:false})
    }
    
    mostrar(){
        this.setState({show:true})
    }

    recaptchaLoaded() {
        this.setState({ recaptchaLoad: true });
    }
    
    verifiedRecaptcha(response) {
        if (response) {
            this.setState({ isVerified: true });
        }
    }

    sendEmail(e) {
        e.preventDefault();
        emailjs.sendForm('service_c6wbtzt', 'template_87pr9kp', e.target, 'user_C6smEMFMth386EZ6bxbcx')
        .then((result) => {
            console.log(result.text);
            this.setState({show:true});
            
        }, (error) => {
            console.log(error.text);
        });
    }

    render(){

        return(
            <div>
            <Navigation/>
                <br/>
            <h1 className="text-center color-texto">Envíenos un correo</h1><br></br>
                <Container className="border border-dark fondo-texto">
                <br/>
                <Form onSubmit={this.sendEmail} >
                    <h2>Información de contacto</h2>
                    <br/>
                <Form.Group as={Row}>
                <Form.Label column sm={2}>
                    Empresa
                    </Form.Label>
                    <Col sm={10}>
                    <Form.Control type="text" placeholder="Ingrese su empresa" name="from_empresa" required/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row}>
                    <Form.Label column sm={2}>
                    Nombre
                    </Form.Label>
                    <Col sm={10}>
                    <Form.Control type="text" placeholder="Ingrese su nombre" name="from_name" required/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={2}>
                    Email
                    </Form.Label>
                    <Col sm={10}>
                    <Form.Control type="email" placeholder="Ingrese su e-mail" name="contact_email" required/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={2}>
                    Teléfono celular
                    </Form.Label>
                    <Col sm={10}>
                    <Form.Control type="tel" placeholder="Ingrese su numero de teléfono celular" name="telefono" required/>
                    </Col>
                </Form.Group>
                <hr></hr>
                <fieldset>
                    <br></br>
                <h2>Información sobre productos que desea cotizar</h2>
                <br/>
                    <Form.Group as={Row}>
                    <Form.Label as="legend" column sm={2}>
                        Categoria
                    </Form.Label>
                    <Col sm={10}>
                        <Form.Check
                        type="checkbox"
                        label="Equipo medico"
                        id="formHorizontalRadios1"
                        name="equipoMedico"
                        />
                        <Form.Check
                        type="checkbox"
                        label="Equipo de rehabilitación"
                        id="formHorizontalRadios2"
                        name="rehabilitacion"
                        />
                        <Form.Check
                        type="checkbox"
                        label="Instrumental"
                        id="formHorizontalRadios3"
                        name="instrumental"
                        />
                        <Form.Check
                        type="checkbox"
                        label="Diagnostico"
                        id="formHorizontalRadios4"
                        name="diagnostico"
                        />
                        <Form.Check
                        type="checkbox"
                        label="Insumo medico"
                        id="formHorizontalRadios5"
                        name="insumo"
                        />
                        <Form.Check
                        type="checkbox"
                        label="Medicamento"
                        id="formHorizontalRadios6"
                        name="medicamento"
                        />
                    </Col>
                    </Form.Group>
                </fieldset>
                <Form.Group controlId="exampleForm.ControlTextarea1" as={Row}>
                    <Form.Label className="text-justify" column sm={2}>Detalle la lista de productos y cantidad a consultar:</Form.Label>
                    <Col sm={10}>
                    <Form.Control as="textarea" rows={5} name="message" required/>
                    </Col>
                </Form.Group>
                <Row>
                    <Col sm={2}>
                    </Col>
                    <Col sm={10}>
                       <Recaptcha
                        sitekey="6LeD59MaAAAAAIWNbk6B_MT-IDf6P0GbgwURUXAB"
                        render="explicit"
                        onloadCallback={this.recaptchaLoaded}
                        verifyCallback={this.verifiedRecaptcha}
                        /> 
                    </Col>
                </Row>
                <Form.Group as={Row}>
                    <Col sm={{ span: 10, offset: 2 }}>
                    <Button type="submit" variant="primary">Enviar</Button>
                    </Col>
                </Form.Group>
                </Form>
                </Container>
                <br/>
                <Footer/>
                <Modal show={this.state.show} onHide={this.ocultar} animation={false}>
                    <Modal.Header closeButton>
                    <Modal.Title>Correo enviado exitosamente</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Nos pondremos en contacto lo mas rapido posible</Modal.Body>
                </Modal>
            </div>
        )
    }
}